export default __webpack_public_path__ + "static/media/My_Highlights_page_empty_1_360x256.962ebcf0.png";